import { useTranslation } from 'react-i18next';

export default function AppSection() {
  const { t } = useTranslation();

  return (
    <section id="app" className="py-16 md:py-24 bg-primary-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Text */}
          <div className="w-full lg:w-1/2 text-center lg:text-left">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
              {t('app.title')}
            </h2>
            <p className="text-sm md:text-base text-background-50/70 mt-4 mb-8 max-w-lg leading-relaxed">
              {t('app.subtitle')}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              {[1, 2, 3, 4].map((n) => (
                <div key={n} className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/20">
                    <i className="ri-check-line text-accent-400 text-sm"></i>
                  </div>
                  <span className="text-sm text-background-50/80">{t(`app.feature${n}`)}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4">
              <a
                href="https://play.google.com/store/apps/details?id=com.sharvayaInfotech.CourtBooking"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 bg-background-50 text-foreground-900 px-6 py-3 rounded-full font-semibold text-sm hover:bg-background-100 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-google-play-fill text-lg"></i>
                </div>
                {t('app.googlePlay')}
              </a>
              <a
                href="https://apps.apple.com/in/app/tennis-club-de-douala/id6752776130"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 bg-background-50 text-foreground-900 px-6 py-3 rounded-full font-semibold text-sm hover:bg-background-100 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-apple-fill text-lg"></i>
                </div>
                {t('app.appStore')}
              </a>
            </div>
          </div>

          {/* Phone Mockup */}
          <div className="w-full lg:w-1/2 flex justify-center">
            <div className="relative">
              <div className="w-64 md:w-72 h-[500px] md:h-[560px] bg-background-50 rounded-[3rem] border-4 border-foreground-800 overflow-hidden shadow-2xl">
                <div className="pt-12 px-4">
                  <div className="bg-primary-500 rounded-2xl p-4 mb-3">
                    <span className="text-background-50 text-xs font-semibold">Tennis Club de Douala</span>
                  </div>
                  <div className="bg-background-100 rounded-xl p-3 mb-2">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-accent-200 flex items-center justify-center">
                        <i className="ri-calendar-line text-accent-700 text-xs"></i>
                      </div>
                      <div>
                        <div className="text-foreground-900 text-xs font-semibold">Court Central</div>
                        <div className="text-foreground-500 text-[10px]">Aujourd'hui · 14:00</div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-background-100 rounded-xl p-3 mb-2">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-accent-200 flex items-center justify-center">
                        <i className="ri-calendar-line text-accent-700 text-xs"></i>
                      </div>
                      <div>
                        <div className="text-foreground-900 text-xs font-semibold">Court 2</div>
                        <div className="text-foreground-500 text-[10px]">Demain · 10:00</div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-accent-500 rounded-xl p-3 mt-4 text-center cursor-pointer">
                    <span className="text-background-50 text-xs font-bold">+ Nouvelle réservation</span>
                  </div>
                </div>
                {/* Bottom nav mock */}
                <div className="absolute bottom-0 left-0 right-0 bg-background-50 border-t border-background-200 px-6 py-3 flex justify-between">
                  <i className="ri-home-4-line text-foreground-400"></i>
                  <i className="ri-calendar-line text-primary-500"></i>
                  <i className="ri-user-line text-foreground-400"></i>
                </div>
              </div>
              {/* Glow effect */}
              <div className="absolute -inset-4 bg-accent-500/10 blur-3xl rounded-full -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}